<form [formGroup]="form">
  <div class="column-selector-content">
    <div class="d-flex justify-content-between flex-column flex-md-row">
      <div class="d-block">
        <h3>{{ 'issue_table_column_selection_title' | translate }}</h3>
        <span class="my-auto">{{ 'issue_table_column_selection_description' | translate: maxSelected }}</span>
      </div>
      <div class="d-block ms-md-3 mt-1 mt-md-0">
        <span class="d-inline-flex info-box border-primary">
          <span class="info-box-title d-block text-primary">
            {{ currentSelectedCount }} / <span class="fw-normal"> {{ maxSelected }}</span>
          </span>
          <span class="d-block"> {{ 'label_columns' | translate }}</span>
        </span>
      </div>
    </div>

    <div class="row margin-top-md" data-test-id="column-filter-options">
      <div class="col-12 col-md-4">
        <h4>{{ 'label_finding_columns' | translate }}</h4>
        @for (column of issueColumns; track column) {
          <div class="ms-0" data-test-id="issue-filters">
            <label class="label d-flex align-items-center margin-bottom-xs">
              <input type="checkbox" (change)="onSelectionChange(column)" [formControlName]="column" [id]="column" />
              <span class="checkbox-label">{{ 'issue_field_' + column | translate }}</span>
            </label>
          </div>
        }
      </div>
      <div class="col-12 col-md-4">
        <h4>{{ 'label_rule_info_columns' | translate }}</h4>
        @for (column of ruleInfoColumns; track column) {
          <div class="ms-0" data-test-id="rule-info-filters">
            <label class="label d-flex align-items-center margin-bottom-xs">
              <input type="checkbox" (change)="onSelectionChange(column)" [formControlName]="column" [id]="column" />
              <span class="checkbox-label">{{ 'issue_field_' + column | translate }}</span>
            </label>
          </div>
        }
      </div>
      <div class="col-12 col-md-4">
        <h4>{{ 'label_activity_columns' | translate }}</h4>
        @for (column of activityColumns; track column) {
          <div class="ms-0" data-test-id="activity-filters">
            <label class="label d-flex align-items-center margin-bottom-xs">
              <input type="checkbox" (change)="onSelectionChange(column)" [formControlName]="column" [id]="column" />
              <span class="checkbox-label">{{ 'issue_field_' + column | translate }}</span>
            </label>
          </div>
        }
      </div>
    </div>

    <div class="d-flex justify-content-start mt-3">
      <button class="btn btn-primary" type="submit" (click)="onApply()">
        {{ 'apply' | translate }}
      </button>
      <button class="btn btn-outline-primary ms-3" (click)="onClose()">
        {{ 'form_cancel' | translate }}
      </button>
    </div>
  </div>
</form>
